import type { GrownCategory, MonthInsight } from '../../model/month-insight.js';
import type { GrownCategoryDto, MonthInsightDto } from '../dto/month-insight.dto.js';

const toGrownCategory = (dto: GrownCategoryDto): GrownCategory => ({
  categoryId: dto.categoryId,
  name: dto.name,
  emoji: dto.emoji,
  spentMinor: dto.spentMinor,
  usualMinor: dto.usualMinor,
});

export const toMonthInsight = (dto: MonthInsightDto): MonthInsight => ({
  year: dto.year,
  month: dto.month,
  baseCurrency: dto.baseCurrency,
  spentMinor: dto.spentMinor,
  usualMinor: dto.usualMinor,
  forecastMinor: dto.forecastMinor,
  daysLeft: dto.daysLeft,
  grown: dto.grown.map(toGrownCategory),
  isSpentApproximate: dto.isSpentApproximate,
  isForecastApproximate: dto.isForecastApproximate,
  isHistoryComplete: dto.isHistoryComplete,
});
